__turbopack_context__.v({
  "back": "NotFound-module__aKyada__back",
  "code": "NotFound-module__aKyada__code",
  "text": "NotFound-module__aKyada__text",
  "wrap": "NotFound-module__aKyada__wrap",
});
